import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';
import * as globalConstant from './../global_constant';

@Injectable({
	providedIn: 'root'
})
export class ExperienceFaqService {
	apiDomain = globalConstant.DOMAIN;
	experienceFaqListApi = globalConstant.EXPERIENCE_FAQ_LIST_API;
	siteRequestFrom = globalConstant.SITE_REQUEST_FROM;

	constructor(private http: HttpClient) {}

	listByEntity(payload: { location_id?: number | string; category_id?: number | string }) {
		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				requestFrom: this.siteRequestFrom
			})
		};
		return this.http
			.post<any>(this.apiDomain + this.experienceFaqListApi, payload || {}, httpOptions)
			.pipe(
				map((res) => res),
				catchError((err) => of(err?.error || { response: 'error', data: [] }))
			);
	}
}
